import React, { useEffect, useState } from "react";
import NoAvatar from "../assets/images/users/no-avatar.jpg";
import { getCrossOrigin } from "utils";

interface IAvatarObj {
  avatarObj:
    | {
        path: string;
      }
    | null
    | undefined;
  className: string;
  style?: object;
  title?: string;
  alt?: string;
}

const ImageComponent: React.FC<IAvatarObj> = ({
  avatarObj,
  className,
  style,
  title,
  alt,
}) => {
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setHasError(false);
  }, [avatarObj?.path]);

  return avatarObj ? (
    avatarObj.path && !hasError ? (
      <img
        src={avatarObj.path}
        className={className}
        crossOrigin={ getCrossOrigin(avatarObj.path) }
        alt={alt || "imagem_perfil"}
        style={{ ...style, overflow: "hidden" }}
        title={title}
        onError={() => setHasError(true)}
      />
    ) : (
      <img
      src={NoAvatar}
      className={className}
      alt={alt || "imagem_perfil"}
      style={{ ...style, overflow: "hidden" }}
      title={title}
    />
    )
  ) : (
    <img
    src={NoAvatar}
    className={className}
    alt={alt || "imagem_perfil"}
    style={{ ...style, overflow: "hidden" }}
    title={title}
  />
  )
};

export default ImageComponent;
